"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const propertyBackDefault_webp_1 = __importDefault(require("../../assets/images/propertyBackDefault.webp"));
const DraggableScroll_1 = __importDefault(require("../dragabbleScroll/DraggableScroll"));
require("./galleryImagesComponent.scss");
const galleryImagesComponentStyles_1 = require("./galleryImagesComponentStyles");
const GalleryImagesComponent = props => {
    const { imagesList, showGalleryScroll, title } = props;
    const [selectedImage, setSelectedImage] = (0, react_1.useState)({ url: '', position: 0 });
    (0, react_1.useEffect)(() => {
        setSelectedImage(imagesList[0]);
    }, [imagesList]);
    const handleChangeImage = (0, react_1.useCallback)((image) => {
        setSelectedImage(image);
    }, []);
    const forward = (0, react_1.useCallback)(() => {
        const index = imagesList.findIndex(image => image.position === selectedImage.position);
        if (index < imagesList.length - 1) {
            setSelectedImage(() => imagesList[index + 1]);
        }
        else {
            setSelectedImage(() => imagesList[0]);
        }
    }, [imagesList, selectedImage.position]);
    const backward = (0, react_1.useCallback)(() => {
        const index = imagesList.findIndex(image => image.position === selectedImage.position);
        if (index === 0) {
            setSelectedImage(() => imagesList[imagesList.length - 1]);
        }
        else {
            setSelectedImage(() => imagesList[index - 1]);
        }
    }, [imagesList, selectedImage.position]);
    return (react_1.default.createElement("div", { className: "GalleryImagesComponent" },
        title && (react_1.default.createElement("div", { className: "GalleryTitleBuilding" },
            react_1.default.createElement("span", { className: "titleBuilding" },
                "Edif\u00EDcio\u00A0",
                react_1.default.createElement("span", { className: "text-style-1" }, title)))),
        react_1.default.createElement(galleryImagesComponentStyles_1.Image, { url: selectedImage.url, className: "selectedImage" }),
        showGalleryScroll && (react_1.default.createElement(galleryImagesComponentStyles_1.GalleryScroll, null,
            react_1.default.createElement(DraggableScroll_1.default, null, imagesList.map(image => (react_1.default.createElement(galleryImagesComponentStyles_1.Thumbnail, { onClick: () => handleChangeImage(image), key: image.position, url: image.url || propertyBackDefault_webp_1.default })))))),
        react_1.default.createElement(galleryImagesComponentStyles_1.ArrowGroup, null,
            react_1.default.createElement("span", { "aria-hidden": "true", className: "noselect", onClick: backward }, `<`),
            react_1.default.createElement("span", { "aria-hidden": "true", className: "noselect", onClick: forward }, `>`))));
};
exports.default = GalleryImagesComponent;
